'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of notification mobile
 */ const NotificationMobile = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.3984",
                y: "71.6973",
                width: "17.4267",
                height: "5.17625",
                rx: "2.33602",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.909 22H63.1865C64.8049 22.009 66.3542 22.6569 67.497 23.8028C68.6398 24.9486 69.2836 26.4996 69.288 28.1178V81.4869C69.2836 83.1081 68.6375 84.6615 67.491 85.8079C66.3445 86.9542 64.7908 87.6002 63.1695 87.6047H40.892C39.2706 87.6002 37.717 86.9542 36.5705 85.8079C35.424 84.6615 34.7779 83.1081 34.7734 81.4869V69.7484V62.1935V60.3381V28.1178C34.7779 26.4937 35.4263 24.9376 36.5765 23.7908C37.7266 22.644 39.2847 22 40.909 22Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.6015 71.7773H45.4891C44.0928 71.7773 42.9609 72.9091 42.9609 74.3052C42.9609 75.7013 44.0928 76.833 45.4891 76.833H58.6015C59.9978 76.833 61.1296 75.7013 61.1296 74.3052C61.1296 72.9091 59.9978 71.7773 58.6015 71.7773Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "49.1445",
                y: "76.834",
                width: "5.98901",
                height: "5.85592",
                rx: "2.92796",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "37.4336",
                y: "24.9277",
                width: "29.4127",
                height: "48.4444",
                rx: "2.86482",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3459_2878)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M58.0184 45.6886C58.0184 45.6886 58.0184 45.7107 58.0184 45.7329C58.0184 45.9098 57.7479 49.6247 53.0817 51.3052V48.9834L55.8995 45.9761C56.1474 45.7107 56.1474 45.2906 55.8544 45.0253C55.5839 44.782 55.1556 44.782 54.8851 45.0695L53.0817 47.0154V45.0253C53.0817 45.0253 53.0817 45.0253 53.0817 45.0031C53.3071 44.4946 54.3891 42.5044 57.0491 42.5044C57.0717 42.5044 57.0942 42.5044 57.1167 42.5044C58.1762 43.7427 58.0184 45.6665 58.0184 45.6886ZM51.7292 47.0154L49.9033 45.0695C49.6553 44.8041 49.227 44.782 48.9565 45.0253C48.686 45.2685 48.6634 45.7107 48.9114 45.9761L51.7292 48.9834V51.2831C47.063 49.6025 46.815 45.8655 46.7925 45.7107C46.7925 45.6886 46.7925 45.6886 46.7925 45.6665C46.7925 45.6444 46.6121 43.7206 47.6716 42.4823C47.6941 42.4823 47.7167 42.4823 47.7618 42.4823C50.4443 42.4823 51.5038 44.4946 51.7292 44.981C51.7292 44.981 51.7292 44.981 51.7292 45.0031V47.0154ZM57.9283 41.3546C57.8155 41.244 57.6577 41.1777 57.5 41.1556C54.9527 41.0008 53.2846 42.2833 52.4054 43.4774C51.5263 42.2833 49.8807 41.0008 47.3109 41.1556C47.1531 41.1556 46.9953 41.244 46.8826 41.3546C45.2371 42.9688 45.4174 45.5338 45.4399 45.7771C45.4399 45.954 45.5526 47.2144 46.3867 48.6738C47.1757 50.0669 48.8438 51.9022 52.1575 52.831C52.18 52.831 52.2026 52.831 52.2026 52.8531C52.2251 52.8531 52.2251 52.8531 52.2476 52.8531C52.2702 52.8531 52.2702 52.8531 52.2927 52.8531C52.3153 52.8531 52.3604 52.8531 52.3829 52.8531C52.4054 52.8531 52.4505 52.8531 52.4731 52.8531C52.4956 52.8531 52.4956 52.8531 52.5181 52.8531C52.5407 52.8531 52.5407 52.8531 52.5632 52.8531C52.5858 52.8531 52.6083 52.8531 52.6309 52.831C58.7849 51.1283 59.3259 46.2636 59.3484 45.7992C59.3709 45.6665 59.5964 43.013 57.9283 41.3546Z",
                    fill: theme.ds5.asset.grey["700"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "67.6223",
                cy: "23.6047",
                r: "10.8449",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M57.9688 34.8739L59.4147 29.8555L62.3492 32.5348L57.9688 34.8739Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M59.376 31.532L59.8241 29.9679L59.2266 29.0881L60.1183 28.5957L63.1487 31.7402L63.0236 32.5179L62.2725 32.1006L60.8121 32.8934L59.376 31.532Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip1_3459_2878)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M67.5633 16.2383C66.926 16.2383 66.4051 16.7308 66.3632 17.3534C67.1238 17.0001 68.0031 17.0001 68.7637 17.3534C68.7218 16.7305 68.2006 16.2383 67.5636 16.2383H67.5633Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M72.412 24.6004C71.9673 24.3358 71.6599 23.8923 71.5539 23.388L70.8844 20.1995C70.574 18.6326 69.1886 17.4863 67.5629 17.4863C65.9372 17.4863 64.5518 18.6326 64.2414 20.1995L63.5737 23.3792C63.4674 23.8859 63.1609 24.3343 62.7138 24.6001C62.3377 24.8238 62.0859 25.2324 62.0859 25.6998C62.0859 26.3494 62.582 26.873 63.2129 26.956H71.913C72.5527 26.8724 73.0487 26.3382 73.0396 25.6814C73.0332 25.2218 72.7829 24.8205 72.4117 24.5998L72.412 24.6004Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M65.918 27.4621C66.1698 28.1232 66.8113 28.5933 67.5643 28.5933C68.3179 28.5933 68.9601 28.1225 69.2113 27.4609L65.918 27.4621Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip0_3459_2878",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "14.2015",
                            height: "11.9407",
                            fill: "white",
                            transform: "translate(45.3047 41.0449)"
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip1_3459_2878",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "10.9536",
                            height: "12.3547",
                            fill: "white",
                            transform: "translate(62.0859 16.2383)"
                        })
                    })
                ]
            })
        ]
    });
};

exports.NotificationMobile = NotificationMobile;
//# sourceMappingURL=NotificationMobile.cjs.map
